import React, {FC} from "react"
import PropTypes from "prop-types"

import RewardWalletBalanceQuery, {RewardWalletBalanceQueryResult} from "@irati/wallet/apollo/query/RewardWallet"
import id from "@irati/utils/id"
import trackingRewardWallet from "@irati-tracking/wallet/rewardWallet"
import {walletTracking} from "@irati-tracking/wallet"
import authentication from "@irati/auth"
import {FormattedMessage} from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Typography"

import WalletLink from "../shared/WalletLink"
import AdminRewardWallet from "../desktop/WalletMenu/AdminRewardWallet"
import UserWalletWithPoints from "../desktop/WalletMenu/UserWalletWithPoints"
import UserWallet from "../desktop/WalletMenu/UserWallet"

const idNamespace = "mobile-wallet-menu"

const MobileWalletDropdown: FC = (_, context) => {
  const showUserCurrencyWallet = authentication.apps("wallet.users")
  const showPerkPoints = authentication.apps("wallet.treatTokens")
  const showRewardWallet = authentication.apps("wallet.rewardWallet")
  const showAdminRewardWallet = authentication.apps("wallet.flexiRewards.canRewardEmployees")

  return (
    <>
      <H4 marginTop={2} marginBottom={2} padding={[0, 2]}>
        <FormattedMessage id="platform.wallet.menu.wrapper.title" />
      </H4>
      {(showUserCurrencyWallet || showPerkPoints || showAdminRewardWallet) && !showRewardWallet ? (
        <UserWalletWithPoints id={idNamespace} onClick={() => walletTracking.clickWalletBalance(context.app, 0, "", "walletDropdown")} />
      ) : (
        <UserWallet
          id={idNamespace}
          text="platform.wallet.menu.user.title"
          onClick={() => walletTracking.clickWalletBalance(context.app, 0, "", "walletDropdown")}
        />
      )}

      {showRewardWallet && (
        <RewardWalletBalanceQuery useLoader={false}>
          {({data}: RewardWalletBalanceQueryResult) => (
            <WalletLink
              id={id("link-reward-wallet", idNamespace)}
              onClick={trackingRewardWallet.clickRewardWallet}
              text="platform.nav.wallet.reward.mobile.text"
              to="/reward"
              useIcon
              wallet={data.rewardWallet}
            />
          )}
        </RewardWalletBalanceQuery>
      )}

      {showAdminRewardWallet && <AdminRewardWallet id={id("link-reward-wallet", idNamespace)} />}
    </>
  )
}

MobileWalletDropdown.contextTypes = {
  app: PropTypes.string.isRequired
}

export default MobileWalletDropdown
